import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap-5';
import { Button } from 'components/ui/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faFile, faFileAlt } from '@fortawesome/pro-solid-svg-icons';

export default function SavePageModal({ pageName, saving, show, onClose, onSave }) {
  const [unscope, setUnscope] = React.useState(false);

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        Page Default Changes
      </Modal.Header>
      <Modal.Body>
        <div className="mb-4">
          You can make these changes to all your documents OR this document only.
        </div>
        <strong className="fw-semibold">
          Where would you like to save these changes?
        </strong>
        <div className="row" onChange={e => setUnscope(e.target.value === 'true')}>
          <label className="radio radio-inline col-5 border px-5 py-4 m-4">
            <input checked={unscope} name="all-documents" readOnly={true} type="radio" value={true} />
            <FontAwesomeIcon className="mx-2" icon={faFile} size="lg"/>
            All Documents
          </label>
          <label className="radio radio-inline col-5 border px-5 py-4 m-4">
            <input checked={!unscope} name="this-document" readOnly={true} type="radio" value={false} />
            <FontAwesomeIcon className="mx-2" icon={faFileAlt} size="lg"/>
            {pageName}
          </label>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={saving} label="Cancel" variant="ghost" onClick={onClose} />
        <Button disabled={saving} label={saving ? 'Saving ...' : 'Save Changes'} onClick={() => onSave(unscope)} />
      </Modal.Footer>
    </Modal>
  );
}

SavePageModal.propTypes = {
  pageName: PropTypes.string,
  saving: PropTypes.bool.isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};
